<template>
  <transition name="career-ai-consent">
    <div
      v-if="visible"
      class="career-ai-consent-overlay"
      @click.self="onCancel"
    >
      <div class="career-ai-consent-window">
        <div class="cac-header">
          <h3>キャリアAI のご利用にあたって</h3>
        </div>

        <div class="cac-body">
          <p class="cac-lead">
            キャリアAI は、転職・キャリア相談を AI と対話形式で進める機能です。
            ご利用いただく前に、データの取り扱いについて以下をご確認ください。
          </p>

          <ul class="cac-list">
            <li>
              <strong>送信される情報：</strong>
              ご相談内容と、履歴書のうち
              <em>年代・都道府県・職歴・学歴・資格・希望条件・自己PR本文</em> を
              Google 社の AI（Vertex AI Gemini）へ送信します。
              <strong
                >氏名・生年月日・住所詳細・電話番号・メールアドレスは送信しません。</strong
              >
            </li>
            <li>
              <strong>会話履歴の保存：</strong>
              会話履歴はサービス改善のため一定期間保存します。ユーザーご自身からは閲覧できません。退会時には削除されます。
            </li>
            <li>
              <strong>学習への利用：</strong>
              送信内容は AI モデルの学習には使用されません（Vertex AI Data Use
              Policy 準拠）。
            </li>
            <li>
              <strong>利用回数：</strong>
              1日あたり
              {{ dailyLimit }}
              メッセージまでご利用いただけます（翌0時にリセット）。
            </li>
            <li>
              <strong>注意事項：</strong>
              キャリアAI
              の応答は参考情報です。医療・法律・税務などの専門助言は行いません。
            </li>
          </ul>
        </div>

        <div class="cac-footer">
          <button class="cac-btn cac-btn--secondary" @click="onCancel">
            キャンセル
          </button>
          <button
            class="cac-btn cac-btn--primary"
            :disabled="submitting"
            @click="onAccept"
          >
            {{ submitting ? '保存中…' : '同意して始める' }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CareerAIConsentDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dailyLimit: {
      type: Number,
      default: 30
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onAccept() {
      this.$emit('accept')
    },
    onCancel() {
      this.$emit('decline')
    }
  }
}
</script>

<style lang="scss" scoped>
.career-ai-consent-overlay {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 55%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 16px;
}

.career-ai-consent-window {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 520px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 12px 40px rgb(0 0 0 / 18%);
}

.cac-header {
  padding: 18px 22px 12px;
  border-bottom: 1px solid #eee;

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: #222;
  }
}

.cac-body {
  padding: 16px 22px;
  overflow-y: auto;
  flex: 1;
  font-size: 13px;
  line-height: 1.7;
  color: #444;
}

.cac-lead {
  margin: 0 0 12px;
}

.cac-list {
  margin: 0;
  padding: 0 0 0 18px;

  li {
    margin-bottom: 10px;
  }

  strong {
    color: #222;
  }

  em {
    font-style: normal;
    color: #008940;
  }
}

.cac-footer {
  padding: 14px 22px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.cac-btn {
  padding: 9px 18px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
  transition:
    background 0.15s ease,
    border-color 0.15s ease;
}

.cac-btn--primary {
  background: #008940;
  color: #fff;

  &:hover:not(:disabled) {
    background: #00702f;
  }

  &:disabled {
    background: #b8b8b8;
    cursor: not-allowed;
  }
}

.cac-btn--secondary {
  background: #fff;
  color: #555;
  border-color: #ccc;

  &:hover {
    background: #f5f5f5;
  }
}

.career-ai-consent-enter-active,
.career-ai-consent-leave-active {
  transition: opacity 0.18s ease;

  .career-ai-consent-window {
    transition: transform 0.18s ease;
  }
}

.career-ai-consent-enter,
.career-ai-consent-leave-to {
  opacity: 0;

  .career-ai-consent-window {
    transform: translateY(8px) scale(0.98);
  }
}

@media (width <= 768px) {
  .career-ai-consent-window {
    max-height: 95vh;
  }
}
</style>
